module.exports = __webpack_public_path__ + "static/media/nasil-calisir.a7851c74.png";